// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelAddress } from './medicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelSubscriber {
    'firstName'?: string | null;
    'middleName'?: string | null;
    'lastName'?: string | null;
    'memberId'?: string | null;
    'gender'?: string | null;
    'birthDate'?: string | null;
    'address'?: MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelAddress | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelSubscriber>> = [
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "memberId",
            "baseName": "memberId",
            "type":     "string"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "string"
        },
        {
            "name":     "birthDate",
            "baseName": "birthDate",
            "type":     "string"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelAddress"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelSubscriber.attributeTypeMap;
    }
}
